export default "__VITE_ASSET__qccJ4CYQ__"